export function checkAndHideZeroReviewElements() {
    const reviewElements = document.querySelectorAll('.yotpo-sr-bottom-line-text.yotpo-sr-bottom-line-text--right-panel');
  
    reviewElements.forEach(reviewElement => {
      const reviewText = reviewElement.textContent.trim();
  
      if (reviewText === '0 Reviews') {
        const widgetElement = reviewElement.closest('.yotpo-widget-instance');
        if (widgetElement) {
          widgetElement.style.display = 'none';
        }
      }
    });
  }


// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/utils.js